
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/signin/[[...signin]]",
      function () {
        return require("private-next-pages/auth/signin/[[...signin]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/signin/[[...signin]]"])
      });
    }
  